//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Assemblies.js";
import "../no/NXObject.js";
let d=[[[0,"IgnoringConstraints",1,0],[0,"Owner",0,"Assemblies.ComponentAssembly",0]],[[["forget_positioning"],"Delete",{},1,0],[[],"GetMaintainsConstraints",{R_:{maintains_constraints:''}},0,0],[[],"GetHasPostponedConstraints",{R_:{postpones_constraints:''}},0,0],[[],"SolvePostponedConstraints",{},0,0],[[],"IsIsolated",{R_:{is_isolated:''}},0,0]],[]];
SPLM.Assemblies.Arrangement = class extends SPLM.NXObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Assemblies.Arrangement";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;